import WebOffice from './src/edit.vue';
/* istanbul ignore next */
WebOffice.install = function(Vue) {
  Vue.component('web-office', WebOffice);
};
export default WebOffice;


// WEBPACK FOOTER //
// ./src/components/oa/view/webOffice/index.js